export enum AuthTrackingEvent {
  Login = 'AS - Login',
  AppLoginPageView = 'app-login-page-view',
  ClickForgotPassword = 'click-forgot-password',
  ForgotPasswordEmailSent = 'forgot-password-email-sent',
  PasswordResetPageLoaded = 'password-reset-page-loaded',
  ClickedSetNewPassword = 'clicked-set-new-password',
}

export enum ProductsTrackingEvent {
  Landing = 'Product-landing',
  LandingClick = 'product-landing-click',
}

export enum NavigationTrackingEvent {
  NavigationToProducts = 'navigation-to-products',
  HelpcenterClick = 'helpcenter-click',
}

export enum PagesTrackingEvent {
  ClickAddPage = 'as-pages-click-add-page',
  PageCreated = 'as-pages-page-created',
  PageEdited = 'as-pages-page-edited',
  PageDeleted = 'as-pages-page-deleted',
  OverviewPropertyFilterApplied = 'as-pages-overview-property-filter-applied',
  DetailPropertyFilterApplied = 'as-pages-detail-property-filter-applied',
  ClickImport = 'as-pages-click-import',
  DownloadImportTemplate = 'as-pages-download-import-template',
  Import = 'as-pages-import',
}

export function buildGoToRouteTrackingEvent(routeName: string): string {
  return `AC-go-to-${routeName}`;
}
